import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Aprendizaje",
  "lead": "En al menos 15 países del África subsahariana, más de la mitad de los estudiantes no alcanzan el nivel mínimo de competencia en lectura al final de la educación primaria."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, HighlightByIndex, IndicatorReference, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_LEARNING"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "Lograr que los niños asistan a la escuela no es suficiente. Sin dejar de lado los muchos otros fines beneficiosos que las escuelas persiguen, y deben perseguir, los estudiantes necesitan ser capaces de leer y efectuar cálculos básicos. Estos son los cimientos de otros aprendizajes, del empoderamiento y el bienestar individuales, así como de los resultados sociales, políticos y económicos."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "niños-y-jóvenes",
      children: "Niños y jóvenes"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1a",
      children: [_jsxs(_components.p, {
        children: ["En algunos de los países más pobres del mundo, muchos niños carecen de aptitudes básicas de lectura y matemáticas. De las evaluaciones de lectura en los primeros cursos escolares en los estados del norte de Nigeria, como Kaduna y Sokoto, y en provincias de la República Democrática del Congo, como Equateur y Katanga, por ejemplo, se desprende que más del 80% de los alumnos de tercer grado de primaria no podía siquiera leer ", _jsx(_components.strong, {
          children: "una sola palabra"
        }), " de un texto estructurado."]
      }), _jsx(Figure, {
        id: "EGRA"
      })]
    }), "\n", _jsx(_components.p, {
      children: "Estos datos no incluyen a los niños que no están escolarizados. Las encuestas realizadas en los hogares pueden tomar en cuenta las aptitudes tanto de los niños que asisten a la escuela, como de los que no lo hacen."
    }), "\n", _jsx(_components.p, {
      children: "En los gráficos que figuran a continuación se examinan diferentes regiones de la India y el Pakistán, de acuerdo con evaluaciones dirigidas por los ciudadanos."
    }), "\n", _jsxs(_components.p, {
      children: ["Las ", _jsx(HighlightByIndex, {
        index: "1",
        children: "líneas rojas"
      }), " muestran el porcentaje de niños ", _jsx(_components.strong, {
        children: "escolarizados"
      }), " que tienen aptitudes básicas de lectura, por grado, mientras que las ", _jsx(HighlightByIndex, {
        index: "0",
        children: "líneas azules"
      }), " muestran el porcentaje de todos los niños que tienen aptitudes básicas de lectura, ", _jsx(_components.strong, {
        children: "escolarizados o no, por la edad que corresponde a su grado"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "Los espacios entre las dos líneas son un recordatorio de que, en los países con altas tasas de niños no escolarizados, los responsables de la formulación de políticas ven solo una imagen parcial si se limitan a supervisar el aprendizaje de los que asisten a la escuela. Es importante señalar que el nivel de aptitud constatado es muy bajo. Incluso en las regiones con mejores resultados, siempre hay algunos adolescentes en la escuela secundaria que no pueden leer un texto de segundo grado."
    }), "\n", _jsx(Figure, {
      id: "LEARN_AGE_GRADE"
    }), "\n", _jsx(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1b",
      children: _jsx(_components.p, {
        children: "Se estima que cerca del 40% de los estudiantes de educación primaria carecen de aptitudes básicas de lectura. Este es el caso del 70% de los de África Subsahariana, pero solo del 3% de los estudiantes de Europa y América del Norte."
      })
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.0",
      label: "4.1.0",
      children: [_jsx(_components.p, {
        children: "En muchos países, no hay garantía de que los niños sepan leer aun cuando han completado la escuela primaria. De aquellos niños que han completado la escuela primaria en el mundo, se estima que cuatro sobre diez no cuentan con habilidades básicas de lectura. Esta cifra aumenta a ocho de cada diez niños en países de bajos ingresos, como lo muestra el siguiente gráfico."
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "LEARN_REACHFINAL"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["Las ", _jsx(HighlightByIndex, {
              index: "-1",
              children: "partes grises"
            }), " muestran el porcentaje de niños que finalizan la escuela primaria, pero no alcanzan un nivel mínimo de competencia en lectura. Las ", _jsx(HighlightByIndex, {
              index: "1",
              children: "partes rojas"
            }), " muestran a los alumnos que finalizan la primaria y alcanzan un nivel mínimo de competencia, y las ", _jsx(HighlightByIndex, {
              index: "0",
              children: "partes azules"
            }), " a los niños que no terminan la educación primaria."]
          })
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "En el plano nacional, en Benín y Nigeria, alrededor del 85% de los jóvenes que abandonaron la escuela tras cinco o seis años no estaba alfabetizado. Sin embargo, las tasas de algunos países son mucho mejores. Así, casi todos los que salieron de la escuela tras el quinto o el sexto grado en Costa Rica y Ruanda estaban alfabetizados."
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "LITBYYRS"
        })
      }), _jsx(ScrollySection, {
        id: "BFA",
        children: _jsxs(_components.p, {
          children: ["En ", _jsx(_components.strong, {
            children: "Kenya"
          }), ", por ejemplo, uno de cada cuatro están alfabetizados ", _jsx(HighlightByIndex, {
            index: "1",
            children: "con cuatro años de escolaridad"
          }), ", pero la proporción asciende a más de tres de cada cuatro en el caso de los que han cursado ", _jsx(HighlightByIndex, {
            index: "0",
            children: "entre cinco y seis años de estudios"
          }), ", el equivalente de la educación primaria."]
        })
      }), _jsx(ScrollySection, {
        id: "NER",
        children: _jsxs(_components.p, {
          children: ["En ", _jsx(_components.strong, {
            children: "el Burkina Faso"
          }), ", ", _jsx(HighlightByIndex, {
            index: "1",
            children: "después de cuatro años de escolarización"
          }), " casi ningún niño es capaz de leer, pero más de la mitad adquiere aptitudes básicas de alfabetización si finaliza ", _jsx(HighlightByIndex, {
            index: "0",
            children: "el ciclo completo de educación primaria"
          }), "."]
        })
      })]
    }), "\n", _jsx(_components.p, {
      children: "Para poder comparar el aprendizaje entre países, es necesario que las evaluaciones o pruebas se ajusten a las normas internacionales empleando una definición común. Recientemente se han establecido normas de este tipo para las evaluaciones internacionales comparadas, en las que alumnos de varios países realizan el mismo examen. No obstante, aún hay menos iniciativas de este tipo para las evaluaciones nacionales."
    }), "\n", _jsx(_components.p, {
      children: "Una evaluación que se lleva a cabo cada cuatro años, el Estudio Internacional de Tendencias en Matemáticas y Ciencias (TIMSS, por sus siglas en inglés), nos permite observar el progreso a lo largo del tiempo entre los alumnos de cuarto y octavo grado. Ésta pone de relieve los lugares en los que los avances han sido particularmente lentos. En los Estados Unidos, por ejemplo, el porcentaje de alumnos de octavo grado que alcanzaba las competencias mínimas en matemáticas aumentó del 61% en 1995 a apenas el 70% en 2015, antes de descender al 55 % en 2023."
    }), "\n", _jsxs(_components.p, {
      children: ["En algunos países, como ", _jsx(HighlightByIndex, {
        index: "0",
        children: "Malasia"
      }), ", la proporción de estudiantes que alcanza niveles mínimos de aprendizaje se ha reducido con el tiempo."]
    }), "\n", _jsxs(_components.p, {
      children: ["En otros, como ", _jsx(HighlightByIndex, {
        index: "1",
        children: "Bahrein"
      }), ", el progreso ha sido rápido: la proporción de estudiantes que alcanza el nivel mínimo de competencia aumentó más del triple entre 2003 y 2019, antes de disminuir en 2023, en consonancia con las tendencias observadas en muchos países."]
    }), "\n", _jsx(Figure, {
      id: "PIRLSGAIN"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1b",
      children: [_jsx(_components.p, {
        children: "Contrariamente a la idea de la mayoría, las brechas de género en el aprendizaje no son amplias, ya que no superan los diez puntos porcentuales en casi ningún país en la educación primaria, por ejemplo."
      }), _jsx(_components.p, {
        children: "Pero las brechas de aprendizaje entre los países son enormes. En los países de África Subsahariana, que tienden a niveles inferiores de las aptitudes de lectura en la educación primaria, la proporción de alumnos que alcanzan competencias mínimas oscilan entre apenas el 5% en Burundi y el 76% en el Gabón (ambas provenientes del PASEC de 2019)."
      }), _jsx(_components.p, {
        children: "En cuanto a las matemáticas en la educación primaria en los países de América Latina, las tasas van de apenas el 17% en la RDP Lao al 89% en el Vietnam (ambas provenientes del SEA-PLM de 2024)."
      }), _jsx(Figure, {
        id: "ASSESS"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "adultos",
      children: "Adultos"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.6.2",
      children: [_jsx(_components.p, {
        children: "Entre 2000 y 2024, el porcentaje de adultos alfabetizados aumentó del 81% al 88% a nivel mundial, mientras que el de jóvenes alfabetizados pasó del 87% al 93%."
      }), _jsx(_components.p, {
        children: "A pesar de estas mejoras, el analfabetismo sigue estando generalizado en muchos países, especialmente entre las mujeres. En América Latina y el Caribe, el estancamiento de los progresos a niveles relativamente altos es un indicio de que existen grupos profundamente desfavorecidos \"difíciles de alcanzar\". En Ecuador, por ejemplo, la tasa de alfabetización de las mujeres adultas en las zonas rurales no ha cambiado mucho en los últimos 20 años, pasando del 81 % en 2001 al 87 % en 2024.."
      }), _jsx(_components.p, {
        children: "En el África Subsahariana, más de 40% de las mujeres adultas (entre 25 y 64 años) no saben leer. En muchos países, los avances se han frenado en niveles muy bajos, como en Malí, donde menos del 17% sabe leer, o han sido lentos, como en Madagascar, que ha pasado del 66 % al 69 % en 20 años."
      }), _jsx(_components.p, {
        children: "Si actualmente hay en el mundo más adultos alfabetizados que antes, ello se debe principalmente a que más adultos fueron a la escuela cuando eran jóvenes, y no a que a los que no lo hicieron se les hubiera brindado una segunda oportunidad de aprender. Para sustentar esta afirmación, el siguiente gráfico muestra datos que hacen un seguimiento de las aptitudes de alfabetización de una determinada cohorte, o grupo, a medida que se vuelve mayor."
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "LITCOHORT"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["En la mayoría de los países, el nivel de alfabetización de una determinada ", _jsx(HighlightByIndex, {
              index: "0",
              children: "cohorte de adultos"
            }), " se estancaba o incluso se reducía con el paso del tiempo debido a que las competencias se infrautilizaban."]
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["En ", _jsx(_components.strong, {
              children: "Burkina Faso"
            }), ", la línea azul muestra que la tasa de alfabetización de ", _jsx(HighlightByIndex, {
              index: "0",
              children: "las mujeres de 20 a 34 años en 2003"
            }), ", ", _jsx(HighlightByIndex, {
              index: "0",
              children: "de 27 a 41 años en 2010"
            }), " y ", _jsx(HighlightByIndex, {
              index: "0",
              children: "de 37 a 62 años en 2021"
            }), " se mantuvo relativamente estable. Sin embargo, como hay más mujeres jóvenes aprendiendo a leer y escribir, la línea roja muestra que ", _jsx(HighlightByIndex, {
              index: "1",
              children: "la tasa de alfabetización entre las mujeres de 20 a 34 años"
            }), " ha ido aumentando a lo largo del tiempo."]
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.6.1",
      children: [_jsx(_components.p, {
        children: "Las aptitudes de alfabetización que miden estas evaluaciones son muy básicas, ya que muestran si una persona es capaz de leer una frase simple. La alfabetización funcional, que supone que las personas pueden leer e interpretar instrucciones escritas, cartas formales o contratos, es una cuestión diferente."
      }), _jsx(_components.p, {
        children: "Pocas encuestas internacionales recogen datos sobre la alfabetización funcional, y mucho menos de forma regular."
      }), _jsx(_components.p, {
        children: "A partir de los datos que tenemos, podemos ver que 1 de cada 10 adultos en Francia, Italia y Nueva Zelanda, y 1 de cada 4 en Chile, no han adquirido una alfabetización funcional (es decir, están por debajo del nivel 1 de competencia de alfabetización funcional)."
      }), _jsx(Figure, {
        id: "LITPROF"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "conclusión",
      children: "Conclusión"
    }), "\n", _jsx(_components.p, {
      children: "Aunque el ODS 4 ha reorientado el énfasis hacia el seguimiento del aprendizaje, muchos países todavía no presentan información acerca de los indicadores de resultados del aprendizaje en lectura y matemáticas. Por otra parte, los países que desean comenzar a emprender evaluaciones e informar sobre el aprendizaje se enfrentan a menudo a obstáculos que les impiden hacerlo de forma eficaz y rentable. No obstante, los datos con los que contamos indican que la mayoría de los alumnos de los países más pobres del mundo no alcanza un nivel mínimo de competencia en las aptitudes más básicas."
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://openknowledge.worldbank.org/handle/10986/32553",
            children: "Ending learning poverty – what will it take? – World Bank"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "http://uis.unesco.org/sites/default/files/documents/ip61-combining-data-out-of-school-children-completion-learning-offer-more-comprehensive-view-sdg4.pdf",
            children: "Combining Data on Out-of-School Children, Completion and Learning to Offer a More Comprehensive View on SDG 4 – UIS"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://gemreportunesco.wordpress.com/2019/05/20/the-learning-assessment-market-pointers-for-countries-part-2/",
            children: "The learning assessment market - pointers for countries"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
